import {createSelector} from 'reselect';

export const getSelectedTasks = (state) => state.taskListState.selectedTasks;

export const getIsTaskNumberSelected = (taskNumber) =>
  createSelector([getSelectedTasks], (selectedTask) => Boolean(selectedTask[taskNumber]));
